import { Contact } from './contact';
import { SensorConfig } from './sensor-config';

export class MobileCurrentGeofence {
  _id: string;
  name: string;
  pgId: number;
  isInside?: boolean;
}

export class MobileCurrentPgData {
  activityConsolistringd: number;
  trequipoId: number;
  ownerId: number;
  vehicleId: number;
  listenerId: number;
  mobileId: number;
}

export class CurrentDayMobile {
  odometer: number;
  hourmeter: number;
  alertCount: number;
  speedMax: number;
  countPositions: number;
}

export class SensorCurrent<T> {
  value: T;
  time: string;
  percentage?: number;
}

export class MobileSensorCurrent {
  fuel: SensorCurrent<number>;
  temperature: SensorCurrent<number>;
}

export class RangeSensorConfig {
  min: number;
  max: number;
}

export class CurrentSensorMobileConfig {
  type: string;
  multiplicative?: number;
  range?: RangeSensorConfig;
  volt?: RangeSensorConfig;
}

export class InputSensorConfig {
  in1: string;
  in2?: string;
  sos: string;
  ad1: string;
  ad2: string;
}

export class CurrentMobileConfig {
  timezone?: string;
  sensors?: SensorConfig[];
  emission?: string;
  geofenceIds?: string[]; // Reemplacé ObjectId por string
}

export class CurrentMobileMaintenance {
  name: string;
  class: string;
  description: string;
  actionType: string;
  value: number | string;
  typeNames: string[];
  isPeriodic: boolean;
  status: string;
  contacts: Contact[];
  startstring: string;
  pgId: number;
  accumulated: number;
  lastCheckTime: string;
}

export class CurrentAlarm {
  pgData: {
    id: number
  };
  key: string;
  name: string;
  type: string;
  value: unknown;
  contacts: Contact[];
  canSendEmail: boolean;
  canSendWhatsapp: boolean;
  ignoreTime?: number;
  lastAlert?: string;
  lastData?: unknown;
  extra: {
    days: string[][],
    hours: Array<{ start: number, end: number }>
  };
}
